export default {
  path: 'temporary-regulations/crews',
  name: 'TemporaryRegulationsCrews',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/CrewsIndex.vue')
}
